export const resend = "ZCFlPd";
export default {resend};